import "./BlogCard.css";
import { Calendar, Clock, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

const BlogCard = ({
  image,
  category,
  title,
  description,
  readTime,
  date,
  slug
}) => {
  return (
    <div className="blog-card">

      <div className="blog-card-image">

        <img
          src={image}
          alt={title}
        />

      </div>

      <div className="blog-card-content">

        <span className="blog-card-category">
          {category}
        </span>

        <h3>{title}</h3>

        <p>{description}</p>

        <div className="blog-card-footer">

          <div className="blog-card-meta">

            <span>
              <Clock size={14} />
              {readTime}
            </span>

            <span>
              <Calendar size={14} />
              {date}
            </span>

          </div>

          <Link
            to={`/blog/${slug}`}
            className="blog-card-button"
          >
            Read Article

            <ArrowRight size={16} />
          </Link>

        </div>

      </div>

    </div>
  );
};

export default BlogCard;